// src/components/auth-nav.js

import React from 'react';
import AuthenticationButton from './authentication-button';

const AuthNav = () => (
  <div className="flex flex-col lg:flex-row gap-2 lg:ml-auto">
    <a
      className="btn btn-outline-dark rounded me-md-2"
      href="/industries/title-companies/#talk-to-us"
    >
      Talk to Us
    </a>
    <AuthenticationButton />
  </div>
);

export default AuthNav;
